<template>
    <b-link
        :to="to"
        @click="$emit('click', $event)"
    >
        <slot />
    </b-link>
</template>

<script>
// Components.
import {BLink} from 'bootstrap-vue'

export default {
    components: {BLink},
    props: {
        to: {type: [Object, String]},
    },
}
</script>